<script lang="ts" setup>
import type { BreadcrumbItem } from "~~/models/breadcrumb";

const { pageTitle } = defineProps<{ pageTitle: string }>();

const { locale, t } = useI18n();

const breadcrumbs = ref([] as Array<BreadcrumbItem>);

if (pageTitle !== t("breadcrumb.home")) {
  breadcrumbs.value.unshift({ title: pageTitle });
}

breadcrumbs.value.unshift({ title: t("breadcrumb.home"), link: "/" });

const cmsData = await useCatalogPage();

const categories = await useCategories();

const { data: productGroupData } = await useFetch("/api/cms/product-groups", {
  query: {
    locale: locale,
  },
});
</script>

<template>
  <div
    v-if="cmsData"
    class="py-sm md:py-lg gap-md flex flex-col justify-between border-b border-neutral-100 md:flex-row md:items-center"
  >
    <div class="flex justify-center md:hidden">
      <HeaderStore />
    </div>

    <div class="gap-md flex flex-wrap items-center">
      <div class="hidden lg:block">
        <ProductCategoryMenuDesktop
          :cms-data="cmsData!"
          :category-tree="categories.tree"
          :product-groups="productGroupData?.allProductGroups"
        />
      </div>

      <div class="block w-full lg:hidden">
        <ProductCategoryMenuMobile
          :cms-data="cmsData!"
          :category-tree="categories.tree"
          :product-groups="productGroupData?.allProductGroups"
        />
      </div>

      <nav v-if="breadcrumbs.length > 1" class="flex text-xs font-medium leading-5" aria-label="Breadcrumbs">
        <ul class="flex flex-wrap">
          <Breadcrumb
            v-for="(item, idx) in breadcrumbs" :key="item.link" :item="item"
            :class="{
              'font-bold': item.title === t('breadcrumb.home'),
              'underline': item.title !== t('breadcrumb.home') && item.link,
              'hidden md:block': idx > 0 && idx < breadcrumbs.length - 1,
            }"
          />
        </ul>
      </nav>
    </div>

    <div class="hidden md:block">
      <HeaderStore />
    </div>
  </div>
</template>

<style scoped>

</style>
